export default {
    methods: {
        copyToClipboard(text, showAlert = true) {
            if (typeof navigator.clipboard == 'undefined') {
                this.$bus.$emit('simple-modal', {
                    title: 'Copiar',
                    message: 'Não foi possível copiar para a área de transferência. Você pode copiar manualmente aqui:' +
                    `<p class="mt-3 t-subtitle text-center">${text}</p>`,
                    showCloseButton: false,
                    btnError: {hide: true},
                    btnSuccess: {color: 'primary', text: 'OK'},
                    persistent: true
                })
                return
            }
            return navigator.clipboard.writeText(text).then(
                () => {
                    if (showAlert) {
                        this.$bus.$emit('feedback', {message: 'Copiado para área de transferência'})
                    }
                },
                (error) => {
                    if (showAlert) {
                        this.$bus.$emit('feedback', {type: 'warning', message: 'Não foi possível copiar o conteúdo'})
                    }

                    console.error(error)
                }
            );
        }
    }
}